import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Index from '@/views/MainPage/Index.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: Index,
  },
  {
    path: '/projects',
    name: 'AllProjects',
    component: () =>
      import(/* webpackChunkName: "Projects" */ '@/views/Projects/Index.vue'),
  },
  {
    path: '/projects/:id',
    name: 'ProjectPage',
    component: () =>
      import(
        /* webpackChunkName: "Project" */ '@/views/Projects/_id/Index.vue'
      ),
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () =>
      import(
        /* webpackChunkName: "PrivacyPolicy" */ '@/views/PrivacyPolicy/Index.vue'
      ),
  },
  // Exmple pages
  {
    path: '/example',
    name: 'ExampleThreeDTour',
    component: () =>
      import(
        /* webpackChunkName: "ExampleThreeDTour" */ '@/views/ExamplePages/ExampleThreeDTour.vue'
      ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
